import { Injectable } from "@angular/core";
import { filter, firstValueFrom } from "rxjs";
import { PrefixedRequestService } from "src/app/core/prefixed-request.service";
import { firstExistentValueFrom, isExistent } from "src/utils";
import { Attachment } from "./attachment.model";
import { HelpAssistTicketReference } from "./models/ticket/base-help-assist-ticket.model";

@Injectable({ providedIn: "root" })
export class AttachmentsService {
  public constructor(private readonly request: PrefixedRequestService) {}

  public async get({ id }: Attachment): Promise<Blob> {
    return firstExistentValueFrom(
      this.request.getBlob({
        prefix: "site",
        path: `/TicketAttachments/{id}`,
        pathParams: { id },
      }),
    );
  }

  public async create(
    ticketId: HelpAssistTicketReference["id"],
    file: File,
  ): Promise<Attachment> {
    const formData = new FormData();
    formData.append("file", file, file.name);

    return await firstExistentValueFrom(
      this.request
        .post({
          prefix: "site",
          path: "/TicketAttachments/{id}",
          pathParams: { id: ticketId },
          data: {
            serialize: () => formData,
          },
          mapResponse: (response, site) =>
            Attachment.deserialize(response, { site }),
        })
        .pipe(filter(isExistent)),
    );
  }

  public async delete({ id }: Attachment): Promise<void> {
    return firstValueFrom(
      this.request.delete({
        prefix: "site",
        path: `/TicketAttachments/{id}`,
        pathParams: { id },
      }),
    );
  }
}
